const colors = {
  black: '#131415',
  white: '#fff',
  pink: '#ff1493',
  gray: '#dedede',
  red: '#E74C3C',
  violet: 'C71585',
}

const relativeColors = {
  primary: colors.pink,
}

export default {
  ...colors,
  ...relativeColors,
}
